// src/styles.js
import { alpha } from '@mui/material/styles';

export const listItemButtonStyle = (active) => ({
  minHeight: 16, // Adjusted height to make it more compact
  padding: '1px 15px', // Adjusted padding
  borderRadius: 0.5,
  typography: 'body2',
  color: 'text.secondary',
  textTransform: 'capitalize',
  fontWeight: 'fontWeightMedium',
  ...(active && {
    color: 'primary.main',
    fontWeight: 'fontWeightSemiBold',
    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
    '&:hover': {
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
    },
  }),
});


export const subListItemButtonStyle = (active) => ({
  minHeight: 16, // Adjusted height to make it more compact
  padding: '1px 32px', // Adjusted padding
  borderRadius: 0.5,
  typography: 'body2',
  color: 'text.secondary',
  textTransform: 'capitalize',
  fontWeight: 'fontWeightMedium',
  ...(active && {
    color: 'primary.main',
    fontWeight: 'fontWeightSemiBold',
    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
    '&:hover': {
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
    },
  }),
  });